import React, { useState, useEffect }  from 'react';
// import { AuthContext } from '../AuthProvider';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
 
import './mycss.css';
import Apiconnect from "../services/Apiconnect.js"; 


const Fgthanks = () => {
      const [bgimg, setBgimg] = useState('');
      const [passwordVisible, setPasswordVisible] = useState(false);

      const [strems, setStreams] = useState([]); 
      const [classes, setClasses] = useState([]); 
      const [infoz, setInfoz] = useState({ username: "", email: "", class_no: "", role: "Student", password: "", stream: "" });    
      const { username, email, class_no, role, password,  stream  } = infoz; 


      const navigate  = useNavigate(); 

      useEffect(() => { 
         getStreams();
         getClasses();
         const randomImageUrl = getRandomImage();
         setBgimg (randomImageUrl);    
     }, [setBgimg]);
 
      const getStreams= async () => {
            Apiconnect.getData("stream_details").then((response) => {                
               setStreams(response.data.stream);
               //console.log(response.data.stream);
            });         
      }
      const getClasses= async () => {
         Apiconnect.getData("class_details").then((response) => {                
            setClasses(response.data.class_no);
            //console.log(response.data.class_no);
         });         
      }
      const getRandomImage = () => {
         const randomNum = Math.floor(Math.random() * 9) + 1; // Generates a number between 1 and 9
         return `admin_codebase/bgpic${randomNum}.jpg`;
      };
      const togglePasswordVisibility = () => {
         setPasswordVisible(!passwordVisible);
      };


      const onInputChange =  e => { 
         setInfoz({ ...infoz, [e.target.name]: e.target.value }); 
         console.log(infoz); 
      };  

      const handleSubmit = async e => {
         e.preventDefault();       
      
             await Apiconnect.postDataNoauth("register", infoz).then((response) => { 
                 console.log(response.data); 
                 if(response.data.status==1)  {
                        setInfoz({ username: "", email: "", class_no: "", role: "Student", password: "", stream: "" });
                        //toast(response.data.message); 
                        //toast('Registered Successfully');
                        navigate("/rgthanks"); 
                 }else{
                     toast.error(response.data.message);
                        //alert(response.data.message); 
                 }    
                 
             });      
        
       };
       
       


  return (
    <>
     

                           
         <div class="container-fluid p-0 vh-100"  >
            <div class="row g-0 vh-100">
            <div class="col-xl-7 example" 
               style={{                   
                  backgroundImage: `url(${bgimg})`, 
                  }} 
                  
                  >
                   
               </div>  
               
               <div class="col-xl-5 vh-100" >
                  <div class="auth-full-page-content p-md-5 p-4"  >
                        <div class="w-100 p-5" >

                           <div class="text-center">
                                 <img style={{maxWidth:'50%', marginBottom:30, }} src="admin_codebase/b-logo.png" />
                                 
                                 <h2><b>Thank you</b></h2> 

                                 <h6> You request to change password has been submitted. Check Inbox for further information.</h6>


                                    <a href="/">Back to Login</a>
                           </div>

                           

                        

                           

                           
                        </div>
                  </div>
               </div> 
            </div>
         </div>
      

         <ToastContainer />
    </>
  );
};

export default Fgthanks;
